import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";

/**
 * Empty-state doctrine (JOB-PAGE-REDESIGN.md §5): an empty section is a
 * single 40px muted row with its primary action — never a full-height card,
 * never an always-open composer.
 */
export function EmptyRow({
    label,
    actionLabel,
    onAction,
    icon,
}: {
    label: string;
    actionLabel?: string;
    onAction?: () => void;
    icon?: ReactNode;
}) {
    return (
        <div className="flex h-10 items-center justify-between gap-2 rounded-md border border-dashed px-3">
            <span className="flex items-center gap-2 text-xs text-foreground/60 truncate">
                {icon}
                {label}
            </span>
            {actionLabel && onAction && (
                <Button size="sm" variant="ghost" className="h-7 px-2 text-xs text-primary shrink-0" onClick={onAction}>
                    {actionLabel}
                </Button>
            )}
        </div>
    );
}
